/* eslint-disable */
import { useParams } from 'react-router-dom';

export default function useParamsRouter() {
    const { credentialTypeId, groupingId, formId } = useParams();
    return {
        credentialTypeIdInt: credentialTypeId ? parseInt(credentialTypeId, 10) : null,
        groupingIdInt: groupingId ? parseInt(groupingId, 10) : null,
        credentialTypeId,
        groupingId,
        formId,
    };
}
